import { render } from "./CompanyRequestInternDataTable.vue?vue&type=template&id=2a385e9b&scoped=true"
import script from "./CompanyRequestInternDataTable.vue?vue&type=script&lang=js"
export * from "./CompanyRequestInternDataTable.vue?vue&type=script&lang=js"

import "./CompanyRequestInternDataTable.vue?vue&type=style&index=0&id=2a385e9b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a385e9b"]])

export default __exports__